var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBell = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.915 13.915v-3.18a6 6 0 0 0-5-5.91v-1.09a1 1 0 1 0-2 0v1.09a6 6 0 0 0-5 5.91v3.18a3 3 0 0 0-2 2.82v2a1 1 0 0 0 1 1h3.14a4 4 0 0 0 7.72 0h3.14a1 1 0 0 0 1-1v-2a3 3 0 0 0-2-2.82Zm-10-3.18a4 4 0 1 1 8 0v3h-8v-3Zm4 10a2.001 2.001 0 0 1-1.72-1h3.44a2 2 0 0 1-1.72 1Zm6-3h-12v-1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1Z",
  fill: "currentColor"
})));

export default SvgBell;